module.exports = __webpack_public_path__ + "media/favicon/mstile-150x150-fda62f40a91ee7c4e4edf16ff29b8170.png";